export default __webpack_public_path__ + "static/media/Team Brainstorming.0c2e075e.svg";